export const PERMISSION_RESOURCE_CODES = {
  home: 'home',
  productCenter: 'product-center',
  productCenterDetail: 'product-center-detail',
  productCenterVersion: 'product-center-version',
  productCategories: 'product-categories',
  productUnits: 'product-units',
  cases: 'cases',
  caseDetail: 'case-detail',
  caseTags: 'case-tags',
  permissions: 'permissions',
} as const;

export const PERMISSION_ACTION_CODES = {
  home: {},
  productCenter: {
    createOffering: 'create-offering',
    editOffering: 'edit-offering',
    stopOffering: 'stop-offering',
    archiveOffering: 'archive-offering',
  },
  productCenterDetail: {
    editOffering: 'edit-offering',
    createSpec: 'create-spec',
    enableSpec: 'enable-spec',
    disableSpec: 'disable-spec',
    createVersion: 'create-version',
  },
  productCenterVersion: {
    publishVersion: 'publish-version',
    cloneVersion: 'clone-version',
    setDefaultVersion: 'set-default-version',
    stopVersion: 'stop-version',
    archiveVersion: 'archive-version',
    editSalesParameters: 'edit-sales-parameters',
    managePackageItems: 'manage-package-items',
    createPrice: 'create-price',
    createResourceMapping: 'create-resource-mapping',
    deleteResourceMapping: 'delete-resource-mapping',
  },
  productCategories: {
    createCategory: 'create-category',
    editCategory: 'edit-category',
  },
  productUnits: { createUnit: 'create-unit', editUnit: 'edit-unit' },
  cases: {
    createCase: 'create-case',
    editCase: 'edit-case',
    deleteCase: 'delete-case',
    publishCase: 'publish-case',
    archiveCase: 'archive-case',
    manageTags: 'manage-tags',
  },
  caseDetail: {
    editCase: 'edit-case',
    deleteCase: 'delete-case',
    publishCase: 'publish-case',
    archiveCase: 'archive-case',
    manageTags: 'manage-tags',
  },
  caseTags: {
    createTag: 'create-tag',
    editTag: 'edit-tag',
    disableTag: 'disable-tag',
    deleteTag: 'delete-tag',
  },
  permissions: {},
};
